import {Controller} from "stimulus"

var stationFilterType;

export default class extends Controller {
    static targets = ["fromDateWrapper", "fromDate", "rangeToggle", "dailyBreakdown"]

    connect() {
        stationFilterType = new URLSearchParams(window.location.search).get('station_filter_type') || 'cash-station-groups';
    }

    getReport(e) {
        this.navigateTo(buildStatusUrl());
    }

    // Navigation seam. Assigning window.location.href is the side effect under
    // test, but jsdom (26+, pulled in by jest-environment-jsdom 30) makes
    // window.location non-configurable and does not implement navigation, so
    // specs can neither stub nor read it back. Routing the redirect through this
    // method lets tests spy on controller.navigateTo to assert the built URL
    // without touching the global. Keep this a thin pass-through.
    navigateTo(url) {
        window.location.href = url;
    }

    setStationFilterType(e) {
        stationFilterType = e.target.dataset.tab;
    }

    toggleDateRange(e) {
        e.preventDefault();
        const isHidden = this.fromDateWrapperTarget.classList.contains('hidden');
        this.fromDateWrapperTarget.classList.toggle('hidden', !isHidden);
        this.rangeToggleTarget.classList.toggle('text-purple-600', isHidden);
        this.rangeToggleTarget.classList.toggle('text-gray-400', !isHidden);

        // When hiding the range, sync from_date to report_date and disable daily breakdown
        if (!isHidden) {
            const reportDate = document.getElementById('report_date').value;
            const fromDateEl = document.getElementById('from_date');
            if (fromDateEl) {
                fromDateEl.value = reportDate;
                if (fromDateEl._flatpickr) {
                    fromDateEl._flatpickr.setDate(reportDate, false);
                }
            }
            if (this.hasDailyBreakdownTarget) {
                this.dailyBreakdownTarget.disabled = true;
                this.dailyBreakdownTarget.checked = false;
            }
        } else {
            this.updateDailyBreakdownState();
        }
    }

    updateDailyBreakdownState() {
        if (!this.hasDailyBreakdownTarget) return;

        const reportDate = document.getElementById('report_date').value;
        const fromDateEl = document.getElementById('from_date');
        const fromDate = fromDateEl ? fromDateEl.value : reportDate;
        const hasValidRange = fromDate && reportDate && fromDate < reportDate;

        this.dailyBreakdownTarget.disabled = !hasValidRange;
        if (!hasValidRange) {
            this.dailyBreakdownTarget.checked = false;
        }
    }
}

// Renamed from reloadReport(): now builds and returns the status URL instead of
// assigning it, so navigation flows through the controller's navigateTo seam.
function buildStatusUrl() {
    const postingDate = document.getElementById('report_date').value;
    const fromDateWrapper = document.querySelector('[data-target="cr-close-out.fromDateWrapper"]');
    const fromDateEl = document.getElementById('from_date');
    const isRangeEnabled = fromDateWrapper && !fromDateWrapper.classList.contains('hidden');
    const fromDate = isRangeEnabled && fromDateEl && fromDateEl.value ? fromDateEl.value : postingDate;
    const onlineOnly = document.getElementById('online_only').checked;
    const ccOnly = document.getElementById('cc_only').checked;
    const activitySourceControls = document.querySelectorAll('.activity-source')
    const crStationControl = document.getElementById("cr_stations")
    const selectedStations = Array.from(crStationControl.querySelectorAll(':checked')).map(option => option.value)
    const crStationGroupControl = document.getElementById("cr_station_groups");
    const selectedStationGroups = Array.from(crStationGroupControl.querySelectorAll(':checked')).map(option => option.value);
    const crGlAccountControl = document.getElementById("gl_accounts");
    const selectedAccounts = Array.from(crGlAccountControl.querySelectorAll(':checked')).map(option => option.value)
    const dailyBreakdownEl = document.getElementById('daily_breakdown');
    const dailyBreakdown = dailyBreakdownEl && !dailyBreakdownEl.disabled && dailyBreakdownEl.checked;
    let activitySources = {}
    Array.from(activitySourceControls).map(el => {
        activitySources[el.id] = el.checked
    })
    return "status?report_date=" + postingDate +
        "&from_date=" + fromDate +
        "&online_only=" + onlineOnly +
        "&cc_only=" + ccOnly +
        "&daily_breakdown=" + dailyBreakdown +
        "&cr_stations=" + encodeURIComponent(selectedStations) +
        "&gl_accounts=" + encodeURIComponent(selectedAccounts) +
        "&activity_sources=" + JSON.stringify(activitySources) +
        "&cr_station_groups=" + encodeURIComponent(selectedStationGroups) +
        "&station_filter_type=" + stationFilterType;
}
